import React, { useCallback, useState } from 'react'
import { Button, Typography } from 'antd'
import { UsergroupAddOutlined } from '@ant-design/icons'

import IntlMessages from '../../util/IntlMessages'
import { trackOnboardingCallCtaClick } from './track-onboarding-call-cta'
import { useOnboardingCallCtaVariant } from './use-onboarding-call-cta-variant'
import { useOnboardingCallCtaBooked } from './use-onboarding-call-cta-booked'
import { OnboardingCallCalendlyEmbedModal } from './OnboardingCallCalendlyEmbedModal'
import './onboarding-call-cta.less'

const { Paragraph, Text } = Typography

interface OnboardingCallCtaWelcomeBlockProps {
  companyId?: string
  userId?: string
}

export const OnboardingCallCtaWelcomeBlock: React.FC<OnboardingCallCtaWelcomeBlockProps> = ({ companyId, userId }) => {
  const abVariant = useOnboardingCallCtaVariant()
  const booked = useOnboardingCallCtaBooked(userId, companyId)
  const [calendlyOpen, setCalendlyOpen] = useState(false)

  const onBook = useCallback(() => {
    trackOnboardingCallCtaClick({
      placement: 'onboarding_modal',
      abVariant,
      companyId,
      userId,
    })
    if (userId && companyId) {
      setCalendlyOpen(true)
    }
  }, [abVariant, companyId, userId])

  const closeCalendly = useCallback(() => setCalendlyOpen(false), [])

  if (booked) {
    return null
  }

  return (
    <div className="onboarding-call-cta-welcome">
      <div className="onboarding-call-cta-welcome__or">
        <Text type="secondary">
          <IntlMessages id="onboarding.callCta.orDivider" />
        </Text>
      </div>
      <div className="onboarding-call-cta-welcome__card">
        <div className="onboarding-call-cta-welcome__card-top">
          <span className="onboarding-call-cta-badge">
            <IntlMessages id="onboarding.callCta.limitedOffer" />
          </span>
        </div>
        <div className="onboarding-call-cta-welcome__card-body">
          <div className="onboarding-call-cta-welcome__icon-wrap">
            <UsergroupAddOutlined aria-hidden />
          </div>
          <div className="onboarding-call-cta-welcome__copy">
            <Paragraph className="onboarding-call-cta-welcome__title">
              <IntlMessages id="onboarding.callCta.title" />
            </Paragraph>
            <Paragraph className="onboarding-call-cta-welcome__desc">
              <IntlMessages id="onboarding.callCta.descriptionShort" />
            </Paragraph>
          </div>
          <Button type="primary" className="onboarding-call-cta-welcome__btn" onClick={onBook}>
            <IntlMessages id="onboarding.callCta.bookNow" />
          </Button>
        </div>
      </div>
      {userId && companyId ? (
        <OnboardingCallCalendlyEmbedModal open={calendlyOpen} onClose={closeCalendly} placement="onboarding_modal" userId={userId} companyId={companyId} />
      ) : null}
    </div>
  )
}
